import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CatalogosIntuiflowService {

  constructor() { }

  catalogoEstado() {
    return [
      {clave: 0, valor: 'Eliminado'},
      {clave: 1, valor: 'Activo'},
      {clave: 2, valor: 'Caducado'},
      {clave: 3, valor: 'ADU'},
    ];
  }

  tiposMaterialesUnidadBase(){
    return [
      {tipo: "ZMPR" },
      {tipo: "ZACC" },
      {tipo: "ZACT" },
      {tipo: "ZINA" },
      {tipo: "ZINV" },
      {tipo: "ZEMP" },
      {tipo: "ZPTA" },
      {tipo: "ZPTG" },
      {tipo: "ZPTH" },
      {tipo: "ZPTM" },
      {tipo: "ZSAG" },
      {tipo: "ZSEH" },
      {tipo: "ZSOL" },
      {tipo: "ZAGU" },
      {tipo: "ZSPL" },
      {tipo: "ZSTQ" },
      {tipo: "ZMPD" },
      {tipo: "ZONP" },
      {tipo: "ZPTT" },
      {tipo: "ZREC" },
      {tipo: "ZSUB" },
      {tipo: "ZDES" },
      {tipo: "ZINV" }      
    ];
  }

}
